module.exports = __webpack_public_path__ + "img/ACA2.eeb5f49e.jpg";